import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import Neuter from '../views/Neuter.vue'
import Ziying from '../views/Ziying.vue'
import Tvlink from '../views/Videolink.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/neuter',
        name: 'Neuter',
        component: Neuter
    },
    {
        path: '/ziying',
        name: 'Ziying',
        component: Ziying
    },
    {
        path: '/all',
        name: 'All',
        component: () => import( '../views/All.vue'),
        children: [
            {
                path: '/brand',
                name: 'Brand',
                component: () => import( '../views/BrandPage.vue')
            },
            {
                path: '/zooy',
                name: 'Zooy',
                component: () => import( '../views/Zooy.vue')
            },
            {
                path: '/landwell',
                name: 'Landwell',
                component: () => import( '../views/Landwell.vue')
            },
            {
                path: '/jwm',
                name: 'Jwm',
                component: () => import( '../views/Jwm.vue')
            },
            {
                path: '/jah',
                name: 'JAH',
                component: () => import( '../views/Jah.vue')
            },
            {
                path: '/gs',
                name: 'GS',
                component: () => import( '../views/Gs.vue')
            },
            {
                path: '/bluecard',
                name: 'Bluecard',
                component: () => import( '../views/Bluecard.vue')
            },
            {
                path: '/zktich',
                name: 'Zktich',
                component: () => import( '../views/Zktich.vue')
            }
            
        ]
    },
    {
        path: '/tvlink',
        name: 'Tvlink',
        component: Tvlink
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
